import followingPageOptions from './utils/followingPageOptions';

export const utils = {
    followingPageOptions,
};
